import { render, staticRenderFns } from "./YeWuShuJu.vue?vue&type=template&id=4d5096c8&scoped=true"
import script from "./YeWuShuJu.vue?vue&type=script&lang=js"
export * from "./YeWuShuJu.vue?vue&type=script&lang=js"
import style0 from "./YeWuShuJu.vue?vue&type=style&index=0&id=4d5096c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5096c8",
  null
  
)

export default component.exports